import { useIntl } from '@umijs/max';

const useI18n = () => {
  const intl = useIntl();

  const formatMessage = (id: string, value?: any) =>
    intl.formatMessage({
      id,
    }, value);

  return {
    formatMessage,
  };
};

export default useI18n;
